import FETCH_SETTINGS from './types';

export const fetchSettings = (): { type: string } => ({
  type: FETCH_SETTINGS.PENDING,
});
